import { jsx as m, jsxs as z } from "react/jsx-runtime";
import * as p from "react";
import { useState as J, useEffect as Q, useId as he, useCallback as U, createElement as pe } from "react";
import { a as xe, c as W } from "./index-eoE_jzLb.js";
import { u as K } from "./index-DoOsnuB6.js";
import { P as O, c as ge } from "./index-D8UDu4KA.js";
import { c as Se, u as ye } from "./index-Dn75bnUs.js";
import { u as be } from "./index-BZPx6jYI.js";
import { u as ve } from "./index-4vbonZJj.js";
import { c as $ } from "./clsx-OuTLNxxd.js";
import { I as Z } from "./Input-Cv8T6BBf.js";
import { L as _e } from "./Label-Bj2Sx48J.js";
import './Slider.css';function ee(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
var te = ["PageUp", "PageDown"], ne = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], oe = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, N = "Slider", [Y, we, Ce] = Se(N), [ie] = ge(N, [
  Ce
]), [ke, L] = ie(N), re = p.forwardRef(
  (e, t) => {
    const {
      name: r,
      min: o = 0,
      max: a = 100,
      step: l = 1,
      orientation: s = "horizontal",
      disabled: i = !1,
      minStepsBetweenThumbs: c = 0,
      defaultValue: f = [o],
      value: y,
      onValueChange: n = () => {
      },
      onValueCommit: u = () => {
      },
      inverted: S = !1,
      form: k,
      ..._
    } = e, x = p.useRef(/* @__PURE__ */ new Set()), h = p.useRef(0), C = s === "horizontal" ? Pe : Ie, [b = [], d] = xe({
      prop: y,
      defaultProp: f,
      onChange: (g) => {
        var P;
        (P = [...x.current][h.current]) == null || P.focus(), n(g);
      }
    }), v = p.useRef(b);
    function D(g) {
      const V = He(b, g);
      R(g, V);
    }
    function M(g) {
      R(g, h.current);
    }
    function A() {
      const g = v.current[h.current];
      b[h.current] !== g && u(b);
    }
    function R(g, V, { commit: P } = { commit: !1 }) {
      const B = Ne(l), F = Me(Math.round((g - o) / l) * l + o, B), T = ee(F, [o, a]);
      d((E = []) => {
        const H = Be(E, T, V);
        if (We(H, c * l)) {
          h.current = H.indexOf(T);
          const q = String(H) !== String(E);
          return q && P && u(H), q ? H : E;
        } else
          return E;
      });
    }
    return /* @__PURE__ */ m(
      ke,
      {
        scope: e.__scopeSlider,
        name: r,
        disabled: i,
        min: o,
        max: a,
        valueIndexToChangeRef: h,
        thumbs: x.current,
        values: b,
        orientation: s,
        form: k,
        children: /* @__PURE__ */ m(Y.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ m(Y.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ m(
          C,
          {
            "aria-disabled": i,
            "data-disabled": i ? "" : void 0,
            ..._,
            ref: t,
            onPointerDown: W(_.onPointerDown, () => {
              i || (v.current = b);
            }),
            min: o,
            max: a,
            inverted: S,
            onSlideStart: i ? void 0 : D,
            onSlideMove: i ? void 0 : M,
            onSlideEnd: i ? void 0 : A,
            onHomeKeyDown: () => !i && R(o, 0, { commit: !0 }),
            onEndKeyDown: () => !i && R(a, b.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: g, direction: V }) => {
              if (!i) {
                const F = te.includes(g.key) || g.shiftKey && ne.includes(g.key) ? 10 : 1, T = h.current, E = b[T], H = l * F * V;
                R(E + H, T, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
re.displayName = N;
var [se, ae] = ie(N, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), Pe = p.forwardRef(
  (e, t) => {
    const {
      min: r,
      max: o,
      dir: a,
      inverted: l,
      onSlideStart: s,
      onSlideMove: i,
      onSlideEnd: c,
      onStepKeyDown: f,
      ...y
    } = e, [n, u] = p.useState(null), S = K(t, (C) => u(C)), k = p.useRef(void 0), _ = ye(a), x = _ === "ltr", h = x && !l || !x && l;
    function I(C) {
      const b = k.current || n.getBoundingClientRect(), d = [0, b.width], D = G(d, h ? [r, o] : [o, r]);
      return k.current = b, D(C - b.left);
    }
    return /* @__PURE__ */ m(
      se,
      {
        scope: e.__scopeSlider,
        startEdge: h ? "left" : "right",
        endEdge: h ? "right" : "left",
        direction: h ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ m(
          le,
          {
            dir: _,
            "data-orientation": "horizontal",
            ...y,
            ref: S,
            style: {
              ...y.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (C) => {
              const b = I(C.clientX);
              s == null || s(b);
            },
            onSlideMove: (C) => {
              const b = I(C.clientX);
              i == null || i(b);
            },
            onSlideEnd: () => {
              k.current = void 0, c == null || c();
            },
            onStepKeyDown: (C) => {
              const d = oe[h ? "from-left" : "from-right"].includes(C.key);
              f == null || f({ event: C, direction: d ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Ie = p.forwardRef(
  (e, t) => {
    const {
      min: r,
      max: o,
      inverted: a,
      onSlideStart: l,
      onSlideMove: s,
      onSlideEnd: i,
      onStepKeyDown: c,
      ...f
    } = e, y = p.useRef(null), n = K(t, y), u = p.useRef(void 0), S = !a;
    function k(_) {
      const x = u.current || y.current.getBoundingClientRect(), h = [0, x.height], C = G(h, S ? [o, r] : [r, o]);
      return u.current = x, C(_ - x.top);
    }
    return /* @__PURE__ */ m(
      se,
      {
        scope: e.__scopeSlider,
        startEdge: S ? "bottom" : "top",
        endEdge: S ? "top" : "bottom",
        size: "height",
        direction: S ? 1 : -1,
        children: /* @__PURE__ */ m(
          le,
          {
            "data-orientation": "vertical",
            ...f,
            ref: n,
            style: {
              ...f.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (_) => {
              const x = k(_.clientY);
              l == null || l(x);
            },
            onSlideMove: (_) => {
              const x = k(_.clientY);
              s == null || s(x);
            },
            onSlideEnd: () => {
              u.current = void 0, i == null || i();
            },
            onStepKeyDown: (_) => {
              const h = oe[S ? "from-bottom" : "from-top"].includes(_.key);
              c == null || c({ event: _, direction: h ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), le = p.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: r,
      onSlideStart: o,
      onSlideMove: a,
      onSlideEnd: l,
      onHomeKeyDown: s,
      onEndKeyDown: i,
      onStepKeyDown: c,
      ...f
    } = e, y = L(N, r);
    return /* @__PURE__ */ m(
      O.span,
      {
        ...f,
        ref: t,
        onKeyDown: W(e.onKeyDown, (n) => {
          n.key === "Home" ? (s(n), n.preventDefault()) : n.key === "End" ? (i(n), n.preventDefault()) : te.concat(ne).includes(n.key) && (c(n), n.preventDefault());
        }),
        onPointerDown: W(e.onPointerDown, (n) => {
          const u = n.target;
          u.setPointerCapture(n.pointerId), n.preventDefault(), y.thumbs.has(u) ? u.focus() : o(n);
        }),
        onPointerMove: W(e.onPointerMove, (n) => {
          n.target.hasPointerCapture(n.pointerId) && a(n);
        }),
        onPointerUp: W(e.onPointerUp, (n) => {
          const u = n.target;
          u.hasPointerCapture(n.pointerId) && (u.releasePointerCapture(n.pointerId), l(n));
        })
      }
    );
  }
), ce = "SliderTrack", de = p.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...o } = e, a = L(ce, r);
    return /* @__PURE__ */ m(
      O.span,
      {
        "data-disabled": a.disabled ? "" : void 0,
        "data-orientation": a.orientation,
        ...o,
        ref: t
      }
    );
  }
);
de.displayName = ce;
var j = "SliderRange", ue = p.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...o } = e, a = L(j, r), l = ae(j, r), s = p.useRef(null), i = K(t, s), c = a.values.length, f = a.values.map(
      (u) => fe(u, a.min, a.max)
    ), y = c > 1 ? Math.min(...f) : 0, n = 100 - Math.max(...f);
    return /* @__PURE__ */ m(
      O.span,
      {
        "data-orientation": a.orientation,
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: i,
        style: {
          ...e.style,
          [l.startEdge]: y + "%",
          [l.endEdge]: n + "%"
        }
      }
    );
  }
);
ue.displayName = j;
var X = "SliderThumb", me = p.forwardRef(
  (e, t) => {
    const r = we(e.__scopeSlider), [o, a] = p.useState(null), l = K(t, (i) => a(i)), s = p.useMemo(
      () => o ? r().findIndex((i) => i.ref.current === o) : -1,
      [r, o]
    );
    return /* @__PURE__ */ m(Re, { ...e, ref: l, index: s });
  }
), Re = p.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, index: o, name: a, ...l } = e, s = L(X, r), i = ae(X, r), [c, f] = p.useState(null), y = K(t, (I) => f(I)), n = c ? s.form || !!c.closest("form") : !0, u = ve(c), S = s.values[o], k = S === void 0 ? 0 : fe(S, s.min, s.max), _ = De(o, s.values.length), x = u == null ? void 0 : u[i.size], h = x ? ze(x, k, i.direction) : 0;
    return p.useEffect(() => {
      if (c)
        return s.thumbs.add(c), () => {
          s.thumbs.delete(c);
        };
    }, [c, s.thumbs]), /* @__PURE__ */ z(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [i.startEdge]: `calc(${k}% + ${h}px)`
        },
        children: [
          /* @__PURE__ */ m(Y.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ m(
            O.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || _,
              "aria-valuemin": s.min,
              "aria-valuenow": S,
              "aria-valuemax": s.max,
              "aria-orientation": s.orientation,
              "data-orientation": s.orientation,
              "data-disabled": s.disabled ? "" : void 0,
              tabIndex: s.disabled ? void 0 : 0,
              ...l,
              ref: y,
              style: S === void 0 ? { display: "none" } : e.style,
              onFocus: W(e.onFocus, () => {
                s.valueIndexToChangeRef.current = o;
              })
            }
          ) }),
          n && /* @__PURE__ */ m(
            Ve,
            {
              name: a ?? (s.name ? s.name + (s.values.length > 1 ? "[]" : "") : void 0),
              form: s.form,
              value: S
            },
            o
          )
        ]
      }
    );
  }
);
me.displayName = X;
var Ve = (e) => {
  const { value: t, ...r } = e, o = p.useRef(null), a = be(t);
  return p.useEffect(() => {
    const l = o.current, s = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(s, "value").set;
    if (a !== t && c) {
      const f = new Event("input", { bubbles: !0 });
      c.call(l, t), l.dispatchEvent(f);
    }
  }, [a, t]), /* @__PURE__ */ m("input", { style: { display: "none" }, ...r, ref: o, defaultValue: t });
};
function Be(e = [], t, r) {
  const o = [...e];
  return o[r] = t, o.sort((a, l) => a - l);
}
function fe(e, t, r) {
  const l = 100 / (r - t) * (e - t);
  return ee(l, [0, 100]);
}
function De(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function He(e, t) {
  if (e.length === 1) return 0;
  const r = e.map((a) => Math.abs(a - t)), o = Math.min(...r);
  return r.indexOf(o);
}
function ze(e, t, r) {
  const o = e / 2, l = G([0, 50], [0, o]);
  return (o - l(t) * r) * r;
}
function Ee(e) {
  return e.slice(0, -1).map((t, r) => e[r + 1] - t);
}
function We(e, t) {
  if (t > 0) {
    const r = Ee(e);
    return Math.min(...r) >= t;
  }
  return !0;
}
function G(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (r - e[0]);
  };
}
function Ne(e) {
  return (String(e).split(".")[1] || "").length;
}
function Me(e, t) {
  const r = Math.pow(10, t);
  return Math.round(e * r) / r;
}
var Ae = re, Te = de, Ke = ue, $e = me;
const Oe = "320px", Le = "600px", Fe = "1025px", Ue = "_output_kueod_37", Ye = "_sliderWrapper_kueod_55", je = "_label_kueod_67", Xe = "_labelContainer_kueod_71", Ge = "_controlsWrapper_kueod_76", qe = "_inputsContainer_kueod_83", Je = "_inputWrapper_kueod_90", Qe = "_sliderContainer_kueod_109", Ze = "_shouldShowBackground_kueod_115", et = "_track_kueod_120", tt = "_slider_kueod_55", nt = "_range_kueod_142", ot = "_thumb_kueod_149", it = "_noValue_kueod_160", rt = "_sliderInput_kueod_180", w = {
  mobile: Oe,
  "mobile-wide": "480px",
  tablet: Le,
  "tablet-wide": "800px",
  desktop: Fe,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  "size-s": "_size-s_kueod_32",
  output: Ue,
  "size-m": "_size-m_kueod_43",
  sliderWrapper: Ye,
  label: je,
  labelContainer: Xe,
  controlsWrapper: Ge,
  inputsContainer: qe,
  inputWrapper: Je,
  sliderContainer: Qe,
  shouldShowBackground: Ze,
  track: et,
  slider: tt,
  range: nt,
  thumb: ot,
  noValue: it,
  sliderInput: rt
}, gt = ({
  className: e,
  label: t,
  shouldShowBackground: r = !1,
  shouldShowLabel: o = !1,
  size: a = "m",
  unit: l,
  withInputs: s = !1,
  ...i
}) => {
  const { max: c = 1 / 0, min: f = -1 / 0, onValueChange: y } = i, [n, u] = J(i.value || i.defaultValue || [0]), [S, k] = J([]);
  Q(() => {
    i.value && u(i.value);
  }, [i.value]), Q(() => {
    k(n.map((d) => String(d)));
  }, [n]);
  const _ = n && n.length <= 1 && n[0] === 0, x = he(), h = `${x}-output`, I = U(
    (d, v) => {
      var V;
      k((P) => {
        const B = [...P];
        return B[d] = v, B;
      });
      const D = parseInt(v, 10);
      if (isNaN(D))
        return;
      const { max: M = 1 / 0, min: A = -1 / 0 } = i, R = Math.max(A, Math.min(D, M));
      if (d === 0 && R > n[1] || d === 1 && R < n[0])
        return;
      const g = [...n];
      g[d] = R, g.some((P, B) => P !== n[B]) && (u(g), (V = i.onValueChange) == null || V.call(i, g));
    },
    [f, c, y, i, n]
  ), C = U(
    (d) => {
      const v = parseInt(S[d], 10), D = n[d === 0 ? 1 : 0], M = isNaN(v), A = v < (f ?? -1 / 0), R = v > (c ?? 1 / 0), g = d === 0 && v > D || d === 1 && v < D;
      M || A || R || g ? k((P) => {
        const B = [...P];
        return B[d] = String(n[d]), B;
      }) : I(d, String(v));
    },
    [S, n, f, c, I]
  ), b = U(
    (d) => {
      u(d), y == null || y(d);
    },
    [y]
  );
  return /* @__PURE__ */ z("div", { className: $(w.sliderWrapper, w[`size-${a}`]), children: [
    o && /* @__PURE__ */ m("div", { className: w.labelContainer, children: /* @__PURE__ */ m(_e, { className: w.label, htmlFor: x, size: "s", children: t }) }),
    /* @__PURE__ */ z("div", { className: w.controlsWrapper, children: [
      /* @__PURE__ */ z(
        "div",
        {
          className: $(w.sliderContainer, {
            [w.shouldShowBackground]: r
          }),
          children: [
            /* @__PURE__ */ z(
              Ae,
              {
                id: x,
                ...!o && { "aria-label": t },
                "aria-describedby": h,
                className: $(w.slider, e),
                ...i,
                onValueChange: b,
                value: n,
                children: [
                  /* @__PURE__ */ m(Te, { className: w.track, children: /* @__PURE__ */ m(Ke, { className: w.range }) }),
                  n.map((d, v) => /* @__PURE__ */ pe(
                    $e,
                    {
                      ...!o && { "aria-label": t },
                      className: $(w.thumb, { [w.noValue]: _ }),
                      key: `${t}-thumb-${v}`
                    }
                  ))
                ]
              }
            ),
            !s && /* @__PURE__ */ z("p", { className: w.output, "data-testid": "slider-output", id: h, children: [
              n.map((d, v) => /* @__PURE__ */ m("span", { children: `${n[v]}${v === n.length - 1 ? "" : "-"}` }, `${t}-output-${v}`)),
              l || ""
            ] })
          ]
        }
      ),
      s && n.length === 2 && /* @__PURE__ */ z("div", { className: w.inputsContainer, children: [
        /* @__PURE__ */ m("div", { className: w.inputWrapper, children: /* @__PURE__ */ m(
          Z,
          {
            className: w.sliderInput,
            disabled: i.disabled,
            max: n[1],
            min: f,
            onBlur: () => C(0),
            onChange: (d) => I(0, d.target.value),
            type: "number",
            value: S[0] ?? ""
          }
        ) }),
        /* @__PURE__ */ m("div", { className: w.inputWrapper, children: /* @__PURE__ */ m(
          Z,
          {
            className: w.sliderInput,
            disabled: i.disabled,
            max: c,
            min: n[0],
            onBlur: () => C(1),
            onChange: (d) => I(1, d.target.value),
            type: "number",
            value: S[1] ?? ""
          }
        ) })
      ] })
    ] })
  ] });
};
export {
  gt as S
};
